import Seller from "./From/Seller";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Notenum from "./Shipping/Notenum";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import Buttons from "../Elements/Buttons";
import List from "./List";
import TargetList from "./Picking/TargetList";
import AccountDate from "./Invoice/Dates/AccountDate";


export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                <Buttons {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-4">
                            <Seller {...componentProps} />
                        </div>
                        <div className="col-md-4">
                            <Target {...componentProps} />
                        </div>
                        <AccountDate
                            col="4"
                            {...componentProps}
                            isClearable={true}
                        />
                    </div>
                    <div className="row form-row">
                        <Shipping {...componentProps} />
                        {/*<Notenum {...componentProps} />*/}
                    </div>
                    <Comment {...componentProps} />
                    <TargetList {...componentProps} />
                </form>
            }
        </Editor>
    </Fragment>;
}